import React from "react";

export default function Ventajas() {
  return (
    <section class="feature section-padding" id="ventaja">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="sectioner-header text-center">
              <h3>Ventajas</h3>
              <span class="line"></span>
              <p>
                En un mundo donde la tecnología avanza rápidamente, la
                digitalización es fundamental para adaptarse a las tendencias
                actuales y futuras.
              </p>
            </div>
            <div class="section-content text-center">
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <div
                    class="media single-feature wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div class="media-body text-right media-right-margin">
                      <h5>Crecimiento Rápido</h5>
                      <p>
                        Puede ayudar a diferenciarse de la competencia y a
                        mantenerse relevante en un mercado en constante
                        evolución.
                      </p>
                    </div>
                    <div class="media-right icon-border">
                      <span class="fa fa-bolt" aria-hidden="true"></span>
                    </div>
                  </div>
                  <div
                    class="media single-feature wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div class="media-body text-right media-right-margin">
                      <h5>Optimización de Procesos</h5>
                      <p>
                        Permite optimizar y agilizar procesos internos, desde la
                        facturación y contabilidad hasta la comunicación interna
                        y la gestión de equipos.
                      </p>
                    </div>
                    <div class="media-right icon-border">
                      <span
                        class="fa fa-battery-full"
                        aria-hidden="true"
                      ></span>
                    </div>
                  </div>
                  <div
                    class="media single-feature wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div class="media-body text-right media-right-margin">
                      <h5>Compatibilidad</h5>
                      <p>
                        En el caso de Cuba, la digitalización también ofrece
                        oportunidades únicas para los negocios cubanos, como la
                        posibilidad de llegar a nuevos clientes y mercados.
                      </p>
                    </div>
                    <div class="media-right icon-border">
                      <span class="fa fa-wifi" aria-hidden="true"></span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none d-md-block d-lg-block">
                  <div class="feature-mobile">
                    <img
                      src="images/phone-screen-with-shadow.png"
                      class="img-fluid wow fadeInUp"
                    />
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div
                    class="media single-feature wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div class="media-left icon-border media-right-margin">
                      <span
                        class="fa fa-check-double"
                        aria-hidden="true"
                      ></span>
                    </div>
                    <div class="media-body text-left">
                      <h5>Actualizaciones rápidas</h5>
                      <p>
                        Brinda la capacidad de tener un mercado totalmente
                        actualizado sobre su producto o servicio, manteniendo al
                        cliente siempre informado de sus avances.
                      </p>
                    </div>
                  </div>
                  <div
                    class="media single-feature wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div class="media-left icon-border media-right-margin">
                      <span class="fa fa-dollar-sign" aria-hidden="true"></span>
                    </div>
                    <div class="media-body text-left">
                      <h5>Generar más ingresos</h5>
                      <p>
                        Permite llegar a un público más amplio y diverso a
                        través de canales en línea, lo que aumenta las
                        oportunidades de venta y la visibilidad de la empresa.
                        Al expandir el alcance, aumentan los ingresos de manera
                        significativa.
                      </p>
                    </div>
                  </div>
                  <div
                    class="media single-feature wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div class="media-left icon-border media-right-margin">
                      <span class="fa fa-hdd" aria-hidden="true"></span>
                    </div>
                    <div class="media-body text-left">
                      <h5>Mejor experiencia del cliente</h5>
                      <p>
                        Una experiencia más personalizada hacia los clientes
                        puede aumentar la satisfacción y fidelidad de estos.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
